import PropTypes from 'prop-types';
import moment from 'moment';
import tinycolor from 'tinycolor2';

import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import CircleIcon from '@mui/icons-material/Circle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';
import {getDays} from '../../helpers/scheduling';
// import './DateTabs.scss';

const getDayObjects = ({days, date}) => days.map((d, i) => {
  const selectedDayKey = date.format('ddd').toUpperCase();
  const selectedDayIndex = days.findIndex(d => d === selectedDayKey);
  const diff = (selectedDayIndex - i) * -1;
  const newDate = moment(date).add(diff, 'days');
  const formattedDay = d.charAt(0) + d.slice(1).toLowerCase();
  return {key: d, name: formattedDay, index: i, date: newDate, dayOfMonth: newDate.format('D')};
});

const DayTabs = props => {
  const {date: jsDate, days, onChange} = props;
  const date = moment(jsDate);
  const day = date.format('ddd').toUpperCase();
  const dayObjects = getDayObjects({days, date});
  return (
    <Box className="DayTabs">
      <Stack direction='row' spacing={0.5}>
        {(dayObjects || []).map(d =>
          <Box
            key={d.key}
            style={{width: 50, cursor: 'pointer'}}
            sx={{'&:hover': {color: 'primary.main'}}}
            onClick={e => onChange(e, d.date.toDate())}
          >
            <Stack
              spacing={0.25}
              paddingBottom='4px'
              justifyContent='space-between'
              alignItems='center'
            >
              <Typography
                variant='large600Tight'
                align='center'
                paddingBottom='0.25em'
                color='text.light'
              >
                {d.name}
              </Typography>
              <Avatar
                style={{
                  backgroundColor: (
                    d.key === day 
                    ? config().colors.primary 
                    : tinycolor(config().colors.primary).lighten(40).toString()
                  ),
                }}
              >
                <Typography 
                  variant='largeBold' 
                  align='center' 
                  lineHeight='normal'
                  style={{color: d.key === day ? 'white' : 'black'}}
                >
                  {d.date.format('D')}
                </Typography>
              </Avatar>
            </Stack>
          </Box>
        )}
      </Stack>
    </Box>
  );
};

DayTabs.defaultProps = {
  date: moment(),
  days: getDays(),
  color: config().colors.primary,
};

DayTabs.propTypes = {
  days: PropTypes.arrayOf(PropTypes.string),
  date: PropTypes.object, // moment.js datetime
  onChange: PropTypes.func,
};

export default DayTabs;
